// Stake Button

increaseStakeButton = {};

increaseStakeButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  button.stakeController = {};
  button._flags.inPromotion = false;
  button._flags.disabledByPlatform = false;

  button.canEnable = function () {
    return (
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._flags.inPromotion &&
      !this._flags.disabledByPlatform
    );
  };

  button.onPressedCallback = function () {
    // Reset autoplay settings
    this.stakeController.showPopup();

    if (button.soundName !== "") {
      button.playSound();
    }
  };

  button.stakeControllerLoaded = function (controller) {
    this.stakeController = controller;
  };

  button.onGameConfigEvent = function (configEvent) {
    var promotionActive = configEvent.data.slotConfig.promotionActive;
    if (promotionActive !== null && promotionActive !== undefined) {
      this._flags.inPromotion = promotionActive;
    }
  };

  button.onPromotionStarted = function () {
    this._flags.inPromotion = true;
  };

  button.onPromotionEnded = function () {
    this._flags.inPromotion = false;
  };

  button.setButtonState = function (data) {
    if (data.buttonName === "Stake") {
      this._flags.disabledByPlatform = !data.enabled;
    }
  };

  messageBus.subscribe(
    "stake:stakeControllerLoaded",
    button.stakeControllerLoaded.bind(button)
  );
  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onGameConfigEvent.bind(button)
  );
  messageBus.subscribe(
    "common:PromotionStarted",
    button.onPromotionStarted.bind(button)
  );
  messageBus.subscribe(
    "common:PromotionEnded",
    button.onPromotionEnded.bind(button)
  );
  messageBus.subscribe(
    "platform:setButtonState",
    button.setButtonState.bind(button)
  );

  return button;
};

increaseStakeButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
increaseStakeButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "increaseStakeButton",
  increaseStakeButton.create,
  increaseStakeButton.initialise,
  increaseStakeButton.getFilesRequired
);
